<template lang="pug">
  div
    lessonHeader
    stepTitle
    approach
    indication
    question
    feedbackModal
    buttonSend
    lessonFooter
</template>

<script>
import stepTitle from '@/components/step-title/step-title'
import approach from '@/components/approach/approach'
import indication from '@/components/indication/indication'
import question from '@/components/question/question'
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import lessonHeader from "@/components/lesson-header/lesson-header";
import buttonSend from "@/components/button-send/button-send";
import feedbackModal from "@/components/feedback-modal/feedback-unique";
export default {
  name: 'Step6',
  components: {
    stepTitle,    
    lessonFooter,
    lessonHeader,
    question,
    buttonSend,
    approach,
    indication,
    feedbackModal
  }  
}
</script>